import { Injectable, inject } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TranslocoService } from '@jsverse/transloco';
import {
  normalizeAppLocale,
  resolveAppDateDisplayFormat,
} from '../constants/date-formats';

/**
 * DatePipe that formats using the active Transloco language and locale-aware
 * display patterns (e.g. German `dd.MMM.yyyy.` with abbreviated months).
 */
@Injectable({ providedIn: 'root' })
export class TranslocoDatePipe extends DatePipe {
  private readonly transloco = inject(TranslocoService);

  constructor() {
    super('en-GB');
  }

  override transform(
    value: Date | string | number | null | undefined,
    format?: string,
    timezone?: string,
    locale?: string,
  ): string | null;
  override transform(
    value: null | undefined,
    format?: string,
    timezone?: string,
    locale?: string,
  ): null;
  override transform(
    value: Date | string | number,
    format?: string,
    timezone?: string,
    locale?: string,
  ): string | null;
  override transform(
    value: Date | string | number | null | undefined,
    format?: string,
    timezone?: string,
    locale?: string,
  ): string | null {
    if (value == null) return null;

    const lang = normalizeAppLocale(
      locale ?? this.transloco.getActiveLang?.() ?? 'en-GB',
    );
    const resolvedFormat = resolveAppDateDisplayFormat(format, lang);

    return super.transform(value, resolvedFormat, timezone, lang);
  }
}
